import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-douyin",
  "use": "icon-douyin-usage",
  "viewBox": "0 0 66.66 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 66.66 80\" id=\"icon-douyin\"><defs><style>#icon-douyin .cls-1{fill:#004626;}</style></defs><path class=\"cls-1\" d=\"M66.57,33.12A30.36,30.36,0,0,1,48.37,27V54.56C48.37,68.62,37.55,80,24.19,80S0,68.62,0,54.56,10.83,29.13,24.19,29.13a22.81,22.81,0,0,1,3.9.33V44a10.3,10.3,0,0,0-3.8-.72,11.36,11.36,0,0,0,0,22.7c5.95,0,10.79-5.08,10.79-11.35V0H48.57c0,10.51,8.1,19,18.09,19V33.11h-.09\" transform=\"translate(0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol